import { render, staticRenderFns } from "./ProfileLabels.vue?vue&type=template&id=154e4d3e"
import script from "./ProfileLabels.vue?vue&type=script&lang=js"
export * from "./ProfileLabels.vue?vue&type=script&lang=js"
import style0 from "./ProfileLabels.vue?vue&type=style&index=0&id=154e4d3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports